import { checkRedirect, thisBaseURL } from "./helper.js";

const FetchUtil = {
	fetchAPI: function(purposeTxt, url, requestOptions, callbackSuccessFunc, callbackFailFunc, completeCallback) {
		if (!purposeTxt || !url) {
			throw new Error("URL is a required parameter");
		}
		const urlContext = thisBaseURL;
		if (!requestOptions) {
			requestOptions = {
				credentials: "same-origin",
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: {},
			}
		}
		if (url.startsWith('/')) {
			url = urlContext + url;
		} else {
			url = urlContext + "/" + url;
		}

		fetch(url, requestOptions)
			.then(async (response) => {
				if (!response.ok) {
					let redirect = false;
					console.log(purposeTxt + ": " +response.status + " " + response.statusText);
					await response.text().then(function(responseTxt) {
						if (checkRedirect(responseTxt)) {
							redirect = true;
							if (callbackFailFunc) {
								callbackFailFunc(redirect, completeCallback);
							}
						}
						if (callbackFailFunc) {
							callbackFailFunc(redirect, completeCallback);
						} else {
							throw new Error("Error!! " + purposeTxt + ": " + response.statusText);
						}
					});


				} else {
					try {
						const responseData = await response.json();
						if (callbackSuccessFunc) {
							callbackSuccessFunc(responseData, completeCallback);
						}
					} catch (error) {
						console.log(purposeTxt + ": " +response.status + " " + response.statusText+ " " + error.message);
						if (callbackFailFunc) {
							let redirect = true;
							callbackFailFunc(redirect, completeCallback);
						} else {
							throw new Error(purposeTxt + ": System encountered an error, please try again. If problem persists contact support.");
						}
					}
				}
			})

		return;
	},
	setUserLanguage: function(i18n, userCtx) {
		let lang = userCtx.lang.split("-");
		if (lang) {
			i18n.changeLanguage(lang[0]);
		} else {
			setBrowserLanguage(i18n);
		}
	},
	setBrowserLanguage: function(i18n) {
		let lang = navigator.language.split("-");
		if (lang) {
			i18n.changeLanguage(lang[0]);
		} else {
			i18n.changeLanguage("en");
		}

	}
}
export default FetchUtil;